export default "__VITE_ASSET__BEJqo_5u__"